import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox } from '@/common/AlertBox';
import { TabsBar } from '@/common/TabsBar';
import {
  type MemberTagFlash,
  MemberTaggingAlertContext,
} from '@/groups/coordinator/MemberTaggingAlertContext';
import { useAdminTabs } from '@/groups/coordinator/useAdminTabs';
import { PageContent } from '@/settings/settingsStyles';

const FLASH_KEYS = {
  added: 'actions.member-tag-added-successfully',
  updated: 'profile.member-tag-updated-successfully',
  deleted: 'actions.member-tag-deleted-successfully',
} as const satisfies Record<MemberTagFlash, string>;

function MemberTaggingLayout() {
  const { t } = useTranslation();
  const adminTabs = useAdminTabs();
  const onIndexPath = useLocation({
    select: (s) => /\/admin\/member-tagging\/?$/.test(s.pathname),
  });
  const [flash, setFlash] = useState<MemberTagFlash | null>(null);

  useEffect(() => {
    if (!onIndexPath) setFlash(null);
  }, [onIndexPath]);

  return (
    <MemberTaggingAlertContext.Provider value={{ setFlash }}>
      <PageContent>
        {flash && <AlertBox variant="success">{t(FLASH_KEYS[flash])}</AlertBox>}
        <TabsBar tabs={adminTabs} base="/groups/$groupName/admin" />
        <Outlet />
      </PageContent>
    </MemberTaggingAlertContext.Provider>
  );
}

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/admin/member-tagging',
)({
  component: MemberTaggingLayout,
});
